import { API, apiConfig, ROUTES } from "../../utils/api.url";
import { createToaster } from "@meforma/vue-toaster";
const toast = createToaster({ position: "top-right", duration: 3000 });

export default {
  namespaced: true,
  state: {
    expenses: [],
    expense: [],
    url: null,
    customer_history: [],
    total: null,
  },
  mutations: {
    SET_EXPENSES(state, data) {
      state.expenses = data;
    },
    SET_EXPENSE(state, data) {
      state.expense = data;
    },
    SET_EXPORTURL(state, data) {
      state.url = data;
    },
    SET_CUSTOMER_HISTORY(state, data) {
      state.customer_history = data;
    },
    REMOVE_EXPENSE(state, id) {
      let expenseIndex = state.expenses.data.findIndex(
        (expense) => expense.id === id
      );
      state.expenses.data.splice(expenseIndex, 1);
    },
    SET_TOTALPAGES(state, data) {
      state.total = data;
    },
  },
  actions: {
    async getExpenses({ commit }, params) {
      const headers = apiConfig().headers;
      let result = await API.get(ROUTES().expenses, { params, headers })
        .then((res) => {
          commit("SET_EXPENSES", res.data);
          commit("SET_TOTALPAGES", res.data.meta.total);
        })
        .catch((err) => {
          if (err.response.data.error) {
            toast.error(`${err.response.data.error}`);
          } else {
            toast.error(`${err.response.data.message}`);
          }
        });
      return result;
    },
    async addExpenses({}, payload) {
      let result = await API.post(ROUTES().expenses, payload, apiConfig(true))
        .then((res) => {
          toast.success(`${res.data.message}`);
        })
        .catch((err) => {
          if (err.response.data.error) {
            toast.error(`${err.response.data.error}`);
          } else {
            toast.error(`${err.response.data.message}`);
          }
        });

      return result;
    },
    async getExpense({ commit }, id) {
      let result = await API.get(`${ROUTES().expenses}/${id}`, apiConfig())
        .then((res) => {
          commit("SET_EXPENSE", res.data.data);
        })
        .catch((err) => {
          console.log(err);
        });

      return result;
    },
    async exportExpense({ commit }) {
      let result = await API.post(
        `${ROUTES().expenses}/export`,
        { format: "excel" },
        apiConfig()
      )
        .then((res) => {
          commit("SET_EXPORTURL", res.data.data.url);
          toast.success("Expenses exported successfully");
        })
        .catch((err) => {
          console.log(err);
        });

      return result;
    },

    async editExpenses({}, { id, payload }) {
      let result = await API.post(
        `${ROUTES().expenses}/${id}/update`,
        payload,
        apiConfig(true)
      )
        .then((res) => {
          toast.success(`${res.data.message}`);
        })
        .catch((err) => {
          if (err.response.data.error) {
            toast.error(`${err.response.data.error}`);
          } else {
            toast.error(`${err.response.data.message}`);
          }
        });

      return result;
    },
    async duplicateExpense({}, id) {
      let result = API.put(
        `${ROUTES().expenses}/${id}/duplicate`,
        {},
        apiConfig()
      )
        .then((res) => {
          toast.success(`${res.data.message}`);
        })
        .catch((err) => {
          if (err.response.data.error) {
            toast.error(`${err.response.data.error}`);
          } else {
            toast.error(`${err.response.data.message}`);
          }
        });
      return result;
    },

    async markAsRefunded({}, { id, payload }) {
      let result = API.put(
        `${ROUTES().expenses}/${id}/mark-as`,
        payload,
        apiConfig()
      )
        .then((res) => {
          toast.success(`${res.data.message}`);
        })
        .catch((err) => {
          if (err.response.data.error) {
            toast.error(`${err.response.data.error}`);
          } else {
            toast.error(`${err.response.data.message}`);
          }
        });
      return result;
    },
    async deleteExpense({ commit }, id) {
      let result = API.delete(`${ROUTES().expenses}/${id}`, apiConfig())
        .then((res) => {
          commit("REMOVE_EXPENSE", id);
          toast.success(`${res.data.message}`);
          return true;
        })
        .catch((err) => {
          if (err.response.data.error) {
            toast.error(`${err.response.data.error}`);
          } else {
            toast.error(`${err.response.data.message}`);
          }
        });
    },
  },
  getters: {
    expenses(state) {
      return state.expenses;
    },
    expense(state) {
      return state.expense;
    },
    url(state) {
      return state.url;
    },
    customer_history(state) {
      return state.customer_history;
    },
    total(state) {
      return state.total;
    },
  },
};
